// extracted by mini-css-extract-plugin
module.exports = {"ad":"search_ad__2hsea","title":"search_title__22rER"};